import React from 'react';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom';

import App from './components/App';
import HttpService from './services/HttpService';
import UserService from './services/UserService';

import './styles/app.global.scss';

const renderApp = () =>
  ReactDOM.render(
    <CookiesProvider>
      <App isLoggedIn={UserService.isLoggedIn} />
    </CookiesProvider>,
    document.getElementById('root'),
  );

UserService.initKeycloak(renderApp);
HttpService.configure();
